import MisconceptionsView from "@features/tools/view/misconceptions-view";

const Misconceptions = () => {
  return <MisconceptionsView />;
};

export default Misconceptions;
